import axios from 'axios';
import { ScenarioModel } from 'types/shared/scenario-model-type.enum';
import { BluViuNutritionSite } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-site-type';

/**
 * Returns a list of sites within the company with the specified globalCompanyId,
 * to which the currently logged in user has access.
 * For each site we also include the number of calibrations and scenarios it has.
 * @param globalCompanyId
 * @returns
 */
// /ewosapi/v2/scenario/sites?globalCompanyId=${globalCompanyId}&scenarioModel={scenarioModel}
export const getR2ScenarioSites = async (
  globalCompanyId: string,
): Promise<BluViuNutritionSite[]> => {
  const res = await axios.get<BluViuNutritionSite[]>(
    `/ewosapi/v2/scenario/sites?globalCompanyId=${globalCompanyId}&scenarioModel=${ScenarioModel.EFFECTIVE_ENERGY_GT_2_MULTI}`
  );

  return res.data;
};
